import React, { useEffect, useState } from "react";
import { getAllOffers } from "../api/HomeApi.services";
import "./OffersMarquee.css";

function OffersMarquee() {

  const [offers, setOffers] = useState([]);

  const fechAllOffers = async function() {
    try {
      const response = await getAllOffers();
      if (response){
        const offersData = response.map((offer) => ({
          text: offer.title,
          link: offer.message,
        }));
        setOffers(offersData);
      }
    } catch (error) {
      console.error("Error fetching offers:", error);
    }
  };

  useEffect(() => {
    fechAllOffers();
  }, []);

  return (
    <div className="offers-marquee py-2">
      <div className="container-fluid overflow-hidden">
        <div className="marquee-container">
          {offers.concat(offers).map((offer, index) => (
            <div key={index} className="offer-item">
              <p className="offer-text">{offer.text}</p>
              <a
                href={ `/product-details/${offer.link}`}
                className="shop-now-button"
                target="_top"
                rel="noopener noreferrer"
              >
                Shop Now
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );  
}

export default OffersMarquee;
